/**
 * Управление переключением табами на детальной матча
 */
$.fn.matchDetailedTabs = function() {
    const $self = $(this);
    const $showTabsButton = $self.find('.js-open-menu');
    const $textHolder = $showTabsButton.find('.js-text-holder');
    const $tabItem = $self.find('.js-tab-item');
    const $menu = $self.find('ul');
    const $menuItems = $menu.find('.js-tab-item');
    const $defaultMenuItem = $menu.find('.js-tab-item.active');
    const $closeButton = $menu.find('.js-detailed-button-menu');
    const openedCssClass = 'opened';


    /**
     * Раскрываем меню табов
     */
    const openMenu = () => {
        $self.addClass(openedCssClass);
        $menu.css('zIndex', '2');
        $showTabsButton.css('zIndex', '-1');
    };

    /**
     * Скрываем меню табов
     */
    const hideMenu = () => {
        $self.removeClass(openedCssClass);
    };

    /**
     * Установить дефолтное значение холдера
     */
    const setDefaultHolder = () => {
        $textHolder.text($defaultMenuItem.text());
    };

    /**
     * Изменить значение холдера
     * @param {string} holderValue
     */
    const changeHolder = (holderValue) => {
        $textHolder.text(holderValue);
    };

    /**
     * Инициализация событий
     */
    const initEvents = () => {
        $showTabsButton.on('click', function () {
            openMenu();
        });

        $menuItems.on('click', function () {
            changeHolder($(this).find('a').text());
            hideMenu();
        });

        $menu.on('transitionend', function () {
            if (!$self.hasClass(openedCssClass)) {
                $menu.css('zIndex', '-1');
                $showTabsButton.css('zIndex', '1');
            }
        })

        $closeButton.on('click', function () {
           hideMenu();
        });
    };

    /**
     * Инициализация плагина
     */
    const init = () => {
        initEvents();
        setDefaultHolder();
    };

    init();

};
